import apiService from './apiService';
import { getApiBaseUrl } from '../config/apiConfig';

const PREFIX = '/agenda/export';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data !== undefined ? res.data : res;
}

async function downloadXml(path, filename = 'export.xml') {
  const base = getApiBaseUrl().replace(/\/+$/, '');
  const url = `${base}${PREFIX}${path}`;
  const token = localStorage.getItem('auth_token') || localStorage.getItem('jwt_token');
  const headers = { Accept: 'application/xml, application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, { method: 'POST', headers });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Erreur HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(link.href);
}

function candidatesQuery({ month, q, thematiqueId, dateFrom, dateTo } = {}) {
  const params = new URLSearchParams();
  if (month) params.set('month', month);
  if (q) params.set('q', q);
  if (thematiqueId) params.set('thematique_id', String(thematiqueId));
  if (dateFrom) params.set('date_from', dateFrom);
  if (dateTo) params.set('date_to', dateTo);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

const agendaExportService = {
  getParution(month) {
    return request(apiService.get(`${PREFIX}/parutions/${month}`));
  },

  candidates(filters = {}) {
    return request(apiService.get(`${PREFIX}/dates/candidates${candidatesQuery(filters)}`));
  },

  thematiques() {
    return request(apiService.get(`${PREFIX}/thematiques`));
  },

  propose(month, replace = true, count = 20) {
    return request(apiService.post(`${PREFIX}/parutions/${month}/propose`, {
      replace,
      dates_count: count,
    }));
  },

  replaceDates(month, dates) {
    return request(apiService.put(`${PREFIX}/parutions/${month}/dates`, { dates }));
  },

  patchDate(month, id, payload) {
    return request(apiService.patch(`${PREFIX}/parutions/${month}/dates/${id}`, payload));
  },

  rewrite(month, ids = null) {
    const body = ids ? { ids } : {};
    return request(apiService.post(`${PREFIX}/parutions/${month}/rewrite`, body, {}, { timeout: 180000 }));
  },

  exportXml(month) {
    return downloadXml(`/parutions/${month}/export`, `agenda-${month}.xml`);
  },
};

export default agendaExportService;
